import moment from 'moment';
import { Strategies } from '@core/lib/serviceWorker/serviceWorker';

export const cacheStrategyKey = 'X-SW-Strategy';
export const cacheMaxAgeKey = 'X-SW-Max-Age-Seconds';
export const cacheNameKey = 'X-SW-Cache-Name';

/**
 * @param requestConfig
 * @returns {Request}
 */
export function swInterceptor(requestConfig) {
  const { cacheStrategy, maxAge, cacheName } = requestConfig;
  const strategy = Strategies[cacheStrategy];

  if (strategy) {
    requestConfig.headers[cacheStrategyKey] = strategy;
  }

  if (strategy && maxAge) {
    const [input, format] = maxAge.split(' ');
    requestConfig.headers[cacheMaxAgeKey] = moment.duration(Number(input), format).asSeconds();
  }

  if (strategy && cacheName) {
    requestConfig.headers[cacheNameKey] = cacheName;
  }

  return requestConfig;
}
